import React, { useEffect } from "react";
import { string, func } from "prop-types";
import { connect } from "react-redux";

import Login from "../../rows/Login";
import { setCurrentPath } from "../../helper/actions";

const LoginPageBase = ({ currentPath, setCurrentPath }) => {
  useEffect(() => {
    setCurrentPath(currentPath);
  }, []);

  return (
    <div>
      <Login currentPath={currentPath} />
    </div>
  );
};

LoginPageBase.propTypes = {
  currentPath: string,
  setCurrentPath: func,
};

const mapDispatchToProps = (dispatch) => ({
  setCurrentPath: (path) => dispatch(setCurrentPath(path)),
});

export const LoginPage = connect(null, mapDispatchToProps)(LoginPageBase);
